import Glide, { Controls, Breakpoints } from "@glidejs/glide/dist/glide.modular.esm";
export default function initGlide(carouselIdentifier, slideOffset = 3) {
    // regardless of the origin of the carousel, we will use the same configuration
    const carouselConfig = {
        type: "slider",
        perView: slideOffset,
        focusAt: 0,
        startAt: 0, // this sets the initial slideIndex, changing it will change the arrow/dot logic
        gap: 25,
        peek: 0,
        swipeThreshold: false,
        dragThreshold: false,
        breakpoints: {
            800: {
                perView: 1,
            },
            480: {
                perView: 1,
            },
        },
    };
    // only execute the logic if there is a glide element on the page
    const glideElement = document.querySelector(".glide");
    if (glideElement) {
        let carousel;
        // chevronHandler and dotHandler are custom handlers that will be used to control the arrows and dots
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const chevronHandler = function (Glide, Components, Events) {
            const blockDisabledArrowAction = (event) => {
                const target = event.target;
                const disabledArrow = target?.closest(".glide__arrow[aria-disabled='true']");
                if (disabledArrow) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            };
            const setControlState = (control, isDisabled) => {
                if (!control) {
                    return;
                }
                control.disabled = isDisabled;
            };
            return {
                mount() {
                    const rootElement = Components.Html.root;
                    rootElement.addEventListener("click", blockDisabledArrowAction, true);
                    rootElement.addEventListener("touchstart", blockDisabledArrowAction, true);
                    Events.on("destroy", () => {
                        rootElement.removeEventListener("click", blockDisabledArrowAction, true);
                        rootElement.removeEventListener("touchstart", blockDisabledArrowAction, true);
                    });
                    Events.on(["mount.after", "move"], () => {
                        const slideIndex = Glide.index;
                        const numOfSlides = Components.Html.slides.length;
                        const currentPerView = Number(Glide.settings?.perView ?? slideOffset);
                        const leftControl = Components.Html.root.querySelector(".glide__arrow--left");
                        const rightControl = Components.Html.root.querySelector(".glide__arrow--right");
                        const isAtStart = slideIndex === 0;
                        const lastStartIndex = Math.max(0, numOfSlides - currentPerView);
                        const isAtEnd = slideIndex >= lastStartIndex;
                        setControlState(leftControl, isAtStart);
                        setControlState(rightControl, isAtEnd);
                    });
                },
            };
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dotHandler = function (Glide, Components, Events) {
            return {
                mount() {
                    Events.on(["mount.after", "move"], () => {
                        const slideIndex = Glide.index;
                        Components.Controls.items.forEach((control) => {
                            // check for data-glide-el="controls[nav]" those are the dots
                            if (control.getAttribute("data-glide-el") === "controls[nav]") {
                                // loop through the children - each of the dots
                                control.childNodes.forEach((child) => {
                                    const dotControl = child;
                                    // if the dot we are currently on is the same as the slideIndex, add the 'active' class
                                    // if not, remove the 'active' class
                                    if (dotControl.getAttribute("data-glide-dir") ===
                                        `=${slideIndex}`) {
                                        dotControl.classList.add("active");
                                        dotControl.setAttribute("aria-current", "true");
                                    }
                                    else {
                                        dotControl.classList.remove("active");
                                        dotControl.removeAttribute("aria-current");
                                    }
                                });
                            }
                        });
                    });
                },
            };
        };
        // some logic will be different depending on the origin of the carousel
        // if carouselIdentifier is a number, we are building a wordpress block
        const isBlock = typeof carouselIdentifier === "number";
        // check if the carouselIdentifier is a number or a ref
        if (isBlock) {
            // target the carousel via it's index class - which is .carousel-index-{carouselIndex}
            const carouselIndex = carouselIdentifier;
            const targetClass = `.carousel-index-${carouselIndex}`;
            // check if the target class actually exists
            const carouselElement = document.querySelector(targetClass);
            if (!carouselElement) {
                console.error(`No carousel with index ${carouselIndex} found`);
                return;
            }
            // create a new instance of Glide - don't mount until we have the chevronHandler and dotHandler
            carousel = new Glide(targetClass, carouselConfig);
        }
        else {
            // target the carousel via the ref
            if (!carouselIdentifier.current)
                return;
            carousel = new Glide(carouselIdentifier.current, carouselConfig);
        }
        // we only need to generate the chevrons if we are building a block `createChevrons`
        carousel.mount({ Controls, Breakpoints, chevronHandler, dotHandler });
    }
}
